
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, RoleId_$reflection } from "../../../Shared/Shared.js";
import { list_type, tuple_type, record_type, class_type, bool_type, option_type, string_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RoleDefinition_$reflection, PermissionGrant_$reflection, Permission_$reflection, SystemRole_$reflection } from "../../../Shared/Roles.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";

export class RoleFormKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["New", "Copy", "Edit"];
    }
}

export function RoleFormKind_$reflection() {
    return union_type("Settings.Roles.Form.Types.RoleFormKind", [], RoleFormKind, () => [[], [["Item", RoleId_$reflection()]], [["Item", RoleId_$reflection()]]]);
}

export class RoleForm extends Record {
    constructor(Name, StoredName, SourceSystemRole, IsSystemRole, Permissions) {
        super();
        this.Name = Name;
        this.StoredName = StoredName;
        this.SourceSystemRole = SourceSystemRole;
        this.IsSystemRole = IsSystemRole;
        this.Permissions = Permissions;
    }
}

export function RoleForm_$reflection() {
    return record_type("Settings.Roles.Form.Types.RoleForm", [], RoleForm, () => [["Name", string_type], ["StoredName", string_type], ["SourceSystemRole", option_type(SystemRole_$reflection())], ["IsSystemRole", bool_type], ["Permissions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Permission_$reflection(), PermissionGrant_$reflection()])]]);
}

export class State extends Record {
    constructor(Kind, CopySuffix, SystemRoleNames, Form, Storages, FormState) {
        super();
        this.Kind = Kind;
        this.CopySuffix = CopySuffix;
        this.SystemRoleNames = SystemRoleNames;
        this.Form = Form;
        this.Storages = Storages;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Roles.Form.Types.State", [], State, () => [["Kind", RoleFormKind_$reflection()], ["CopySuffix", string_type], ["SystemRoleNames", list_type(tuple_type(SystemRole_$reflection(), string_type))], ["Form", RequestedValue$1_$reflection(RoleForm_$reflection())], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetGrant", "Save", "RolesFetched", "StoragesFetched", "RoleSaved", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Roles.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item1", Permission_$reflection()], ["Item2", PermissionGrant_$reflection()]], [], [["Item", list_type(RoleDefinition_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", ClientApiResponse$1_$reflection(RoleId_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

